import React, { useState } from 'react';
import { api as axios } from '../utils/apiClient';
import Sidebar from './Sidebar';
import './EmailRegistration.css';

const EmailRegistration = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null); // 'success' or 'error'

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear message when user starts typing
    if (message) {
      setMessage(null);
      setMessageType(null);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setMessageType(null);

    // Validation
    if (!formData.email.trim()) {
      setMessage('Please enter your email address.');
      setMessageType('error');
      return;
    }

    if (!validateEmail(formData.email.trim())) {
      setMessage('Please enter a valid email address.');
      setMessageType('error');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/api/register', {
        email: formData.email.trim(),
        username: formData.username.trim() || undefined,
      });

      if (response.data.success) {
        setMessage(`Welcome email sent successfully to ${formData.email}!`);
        setMessageType('success');
        // Reset form
        setFormData({
          email: '',
          username: '',
        });
      } else {
        setMessage(response.data.message || 'Failed to send welcome email.');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Error sending welcome email:', error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to send welcome email. Please check your connection and try again.';
      setMessage(errorMessage);
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container email-registration-page">
      <Sidebar />
      <div className="main-content">
        <div className="email-registration-header">
          <h1>Email Registration</h1>
          <p className="subheading">
            Register your email to receive welcome notifications and updates from WebMonitor.
          </p>
        </div>

        <div className="email-registration-card">
          <form onSubmit={handleSubmit} className="email-registration-form">
            <div className="form-group">
              <label htmlFor="email">
                Email Address <span className="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Username (Optional)</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                placeholder="John Doe"
                disabled={loading}
              />
              <small className="form-hint">If not provided, we'll use your email name.</small>
            </div>

            {message && (
              <div className={`form-message ${messageType}`}>
                {messageType === 'success' ? '✅ ' : '❌ '}
                {message}
              </div>
            )}

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Sending...
                </>
              ) : (
                'Send Welcome Email'
              )}
            </button>
          </form>

          <div className="email-registration-info">
            <h3>What happens next?</h3>
            <ul>
              <li>You'll receive a welcome email at the address you provided</li>
              <li>We'll notify you about updates and maintenance alerts</li>
              <li>Your email will be used for important WebMonitor notifications</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailRegistration;

